import React, { useEffect, useState } from "react";
import passengerIcon from "../imgs/add-passenger.png"
import safetyIcon from "../imgs/traffic-light.png"
import maintenanceIcon from "../imgs/maintenance.png"
import benefitsIcon from "../imgs/benefits.png"
import gasoline from "../imgs/gasoline.png";
import book from "../imgs/open-book.png"
import accidentsIcon from "../imgs/airbag.png"
import documentIcon from "../imgs/document.png"
import express from "../imgs/express.png"
import news from "../imgs/newspaper.png"


import scanIcon from '../imgs/work/qr-scan.png';
import {Link} from "react-router-dom";
import { IonPage, IonHeader, IonToolbar, IonContent, IonFooter, createGesture, IonIcon } from "@ionic/react";
import Nav from "./Nav";
import Toolbar from "./Toolbar";
import { sidnavStore, SidenavState } from "../api/SidenavStore";
import { ApiService } from "../api/ApiService";
import { getRecentClaimGroup } from "../utils/ClaimUtils";
import { UserState, userStore } from "../api/AuthService";

//walkthrough import
import DocsFirstIn from "../components/walkthrough/DocsFirstIn";
import { cameraOutline } from "ionicons/icons";

const Docs = () => {

        const {open, close}: { open: boolean, close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
        const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));
        const { driver } = userStore((state: UserState) => ({ driver: state.driver }));
        
        const ref = React.useRef<HTMLInputElement>(null)
        const [hasOpenClaim, setHasOpenClaim] = useState(false);
    
        useEffect(() => {
            gestureInit();
        }, [])

        useEffect(() => {
            if (!driver?.unit) {
                return;
            }

            ApiService.claimCheck('docs', driver.unit)
                .then(claims => setHasOpenClaim(!!getRecentClaimGroup(claims).mostRecentClaim))
                .catch(() => setHasOpenClaim(false));
        }, [driver?.unit])
    
        const gestureInit = () => {
            const card = ref.current
            if (card) {
                const gesture = createGesture({
                    el: card,
                    gestureName: 'swipeMenu',
                    onMove: (detail) => {
                        console.log("moving");
                    },
                    onEnd: (detail) => {
                        console.log("move ended");
                        toggleSidenav();
                    }                 
                })
                gesture.enable();
            }
        }

    return (
        <DocsFirstIn>
        <IonPage>
        <IonHeader>
            <IonToolbar color="primary">
                <Toolbar pageName="Docs"/>
            </IonToolbar>
        </IonHeader>
        <IonContent fullscreen color="light">
            <div ref={ref} onClick={() => close()} style={{height: "80vh"}}>
                <div className="item-container">
                    <div id="WholeDocsSection">
                        <div className="grid50">
                            <Link className="western-button-link" to="/safety">
                                <div>
                                    <img src={safetyIcon} alt="key" className="link-icon"/><p>Safety</p>
                                </div>
                            </Link>
                        
                            <Link className="western-button-link" to="/maintenancevids">
                                <div>
                                    <img src={maintenanceIcon} alt="key" className="link-icon"/><p>Maintenance</p>
                                </div>
                            </Link>

                            <Link className="western-button-link" to="/benefits">
                                <div>
                                    <img src={benefitsIcon} alt="key" className="link-icon"/><p>Benefits</p>
                                </div>
                            </Link>

                            <Link className="western-button-link" to="/permits">
                                <div>
                                    <img alt="key" className="link-icon" src={documentIcon} /><p>Permits</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <Link className="western-button-link" to="/contracts" id="Contracts">
                        <div>
                            <img src={news} alt="key" className="link-icon"/><p>Contracts</p>
                        </div>
                    </Link>
                    {hasOpenClaim && (
                        <Link className="western-button-link" to="/claims" id="Claim">
                            <div>
                                <IonIcon icon={cameraOutline} className="link-icon" /><p>Claim Photos</p>
                            </div>
                        </Link>
                    )}
                    <Link className="western-button-link" to="/accidentinfo" id="Accidents">
                        <div className="red">
                            <img src={accidentsIcon} alt="key" className="link-icon"/><p>Accidents</p>
                        </div>
                    </Link>
                </div>
            </div>
        </IonContent>
        <IonFooter>
            <Nav pageName="Docs" onSearch={function (target: boolean): void {
                    console.log("Not ready");
                } }/>
        </IonFooter>
        </IonPage>
        </DocsFirstIn>
    )
}

export default Docs
